import { FormHandler } from './handlers/form'
import './lib/iframe-resizer'
import './scss/form.scss'

(window as any)['embeddedForm'] = new FormHandler({
    selector: '.embed-form',
})
